module.exports = __webpack_public_path__ + "static/media/custom-checkbox-1-unchecked.e2aa3409.svg";